import { Polyline } from "react-leaflet";
import { SingleRouteResponse } from "../../services/RoutingAdapter"
import { useFromAddress, useToAddress } from "../../stores/RouteLocationStore"
import { LatLngExpression } from "leaflet";
import { AddressItem } from "../../services/GeocodeService"
import { useIsLoading } from "../../stores/RouteStore";

export interface IDashedSnapLineProps {
    route: SingleRouteResponse    
}

function getCoordinatesFromAddressLocation(address: AddressItem): [number, number] {    
    const {location} = address;

    const tuple = location as [number, number]
    return [ tuple[1], tuple[0] ]
}

function getFirstRoutePoint(route: SingleRouteResponse): [number, number] {
    const {features} = route;
    const startPosition = features[0].geometry.coordinates[0];

    return [ startPosition[1], startPosition[0] ];
}

function getLastRoutePoint(route: SingleRouteResponse): [number, number] {
    const {features} = route;
    const coordinates = features[features.length-1].geometry.coordinates;
    const lastCoordinate = coordinates[coordinates.length-1];
    return [ lastCoordinate[1], lastCoordinate[0] ];
}

interface IDashedLineFromAddressItem extends IDashedSnapLineProps {
    addressItem: AddressItem,
    routePoint: [number, number]
}

function DashedLineFromAddress(props: IDashedLineFromAddressItem) {
        
    const {features} = props.route;

    const startLocations = features[0].geometry.coordinates[0];
    const startPositions: LatLngExpression[] = [
        props.routePoint,
        getCoordinatesFromAddressLocation(props.addressItem)
    ] 
        
    return (
        <Polyline positions={startPositions} pathOptions={{color: "#777777", dashArray: [10, 10]}}></Polyline>        
    )
}

export function DashedSnapLine(props: IDashedSnapLineProps) {

    const fromAddress = useFromAddress();
    const toAddress = useToAddress();
    const isLoading = useIsLoading();

    return (
        <>
            {fromAddress && !isLoading &&
                <DashedLineFromAddress route={props.route} addressItem={fromAddress} routePoint={getFirstRoutePoint(props.route)}/>
            }
            {toAddress && !isLoading &&
                <DashedLineFromAddress route={props.route} addressItem={toAddress} routePoint={getLastRoutePoint(props.route)}/>
            }
        </>
    )
}